import React, { useEffect, useRef } from 'react'

const scrollAnchorStyle = { opacity: 0, height: 0 }

interface ScrollAnchorProps {
  autoScroll?: boolean
  block?: ScrollLogicalPosition
  scrollContainer?: HTMLElement | null
  testId: string
}

const ScrollAnchor = ({
  autoScroll = false,
  block = 'end',
  testId,
  scrollContainer,
}: ScrollAnchorProps) => {
  const scrollerRef = useRef<HTMLDivElement>(null)
  const hasScrolledRef = useRef(false)

  useEffect(() => {
    if (!autoScroll) {
      hasScrolledRef.current = false
      return
    }

    if (scrollerRef.current && !hasScrolledRef.current) {
      hasScrolledRef.current = true

      const attemptScroll = (attempt = 1, maxAttempts = 10) => {
        const hasScrollableContent =
          scrollContainer &&
          scrollContainer.scrollHeight > scrollContainer.clientHeight

        if (!hasScrollableContent && attempt < maxAttempts) {
          // Content not ready yet, retry after another frame
          requestAnimationFrame(() => attemptScroll(attempt + 1, maxAttempts))
          return
        }

        // Content ready or max attempts reached, execute scroll
        scrollerRef.current?.scrollIntoView({ block, behavior: 'auto' })
      }
      attemptScroll()
    }
  }, [autoScroll, block, scrollContainer])

  return (
    <div
      data-testid={`${testId}-scroll-anchor`}
      ref={scrollerRef}
      style={scrollAnchorStyle}
    />
  )
}

export default ScrollAnchor
